var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{attrs:{"to":"https://darksky.net/poweredby/"}},[_vm._v("\n  Powered By Dark Sky\n")])}
var staticRenderFns = []

export { render, staticRenderFns }